module.exports = __webpack_public_path__ + "img/Flag_of_Cameroon.c1a90312.svg";